import React from 'react';
import { SYMBOL_LEGEND } from '../../lib/chartGlyphs';

const ChartQuickstart = ({ quickstart }) => {
  if (!quickstart) return null;
  return (
    <section className="card chart-quickstart">
      <h2>Read this chart in 30 seconds</h2>
      <p className="chart-help">
        Pattern first, detail second. Use this as your orientation layer before studying each placement.
      </p>

      <div className="chart-summary-grid">
        <article>
          <h4>Big Three</h4>
          <p>{quickstart.bigThree}</p>
        </article>
        <article>
          <h4>Main emphasis</h4>
          <p>{quickstart.mainEmphasis}</p>
        </article>
        <article>
          <h4>Angles</h4>
          <p>{quickstart.angles}</p>
        </article>
        <article>
          <h4>Strongest aspects</h4>
          <ul className="chart-quick-list">
            {quickstart.strongestAspects.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      </div>

      <div className="chart-sentence-card">
        <h4>Start here summary</h4>
        <p>{quickstart.overview}</p>
      </div>

      <div className="chart-sentence-card">
        <h4>Suggested reading order</h4>
        <ol className="chart-quick-order">
          <li>Start with your Sun, Moon, and Rising.</li>
          <li>Notice which sign or house repeats most.</li>
          <li>Locate ASC and MC to anchor chart direction.</li>
          <li>Then read aspects and individual placements.</li>
        </ol>
      </div>

      <details className="chart-symbol-key">
        <summary>Symbol key</summary>
        <div className="chart-symbol-key-grid">
          <div>
            <strong>Planets:</strong> {SYMBOL_LEGEND.planets.slice(0, 5).map((p) => `${p.glyph} ${p.name}`).join(' · ')} …
          </div>
          <div>
            <strong>Signs:</strong> {SYMBOL_LEGEND.signs.slice(0, 4).map((s) => `${s.glyph} ${s.name}`).join(' · ')} …
          </div>
          <div>
            <strong>Aspects:</strong> {SYMBOL_LEGEND.aspects.map((a) => `${a.glyph} ${a.name}`).join(' · ')}
          </div>
        </div>
      </details>
    </section>
  );
};

export default ChartQuickstart;
